module.exports = __webpack_public_path__ + "img/bidOfflineFlow.22a8e4df.jpg";